import { IonRadioGroup } from '@ionic/react'

type RadioGroupProps = {
  value: string
  onChange: (value: string) => void
  children: React.ReactNode
  name?: string
}

export const RadioGroup = ({
  value,
  onChange,
  children,
  name = 'radio-group',
}: RadioGroupProps) => {
  return (
    <IonRadioGroup
      value={value}
      onIonChange={(e) => onChange(e.detail.value)}
      name={name}
    >
      {children}
    </IonRadioGroup>
  )
}
